import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="relative">
          <div className="w-full aspect-[4/5] max-w-md mx-auto lg:max-w-none rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20heartfelt%20scene%20of%20Malaysian%20community%20volunteers%20distributing%20food%20aid%20packages%20to%20smiling%20elderly%20and%20children%2C%20soft%20natural%20light%2C%20warm%20emerald%20and%20amber%20tones%2C%20documentary%20photography%20style%2C%20hopeful%20compassionate%20mood%2C%20shallow%20depth%20of%20field&width=900&height=1100&seq=nur-about-01&orientation=portrait"
              alt="Volunteers distributing food aid in Kuching"
              title="Insani Darul Hana charity aid volunteers"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-4 left-4 md:left-8 bg-accent-500 text-background-50 rounded-lg px-4 py-3 text-center">
            <div className="font-heading font-bold text-xl">2021</div>
            <div className="text-[11px] opacity-90">{t('about.reg')}</div>
          </div>
        </div>

        <div>
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold uppercase tracking-wide">
            {t('about.tag')}
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-tight">
            {t('about.title')}
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            {t('about.p1')}
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            {t('about.p2')}
          </p>

          <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="rounded-lg border border-background-200 bg-white p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-focus-3-line"></i>
                </span>
                <span className="font-heading font-semibold text-foreground-900">
                  {t('about.mission')}
                </span>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {t('about.missionText')}
              </p>
            </div>
            <div className="rounded-lg border border-background-200 bg-white p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-eye-line"></i>
                </span>
                <span className="font-heading font-semibold text-foreground-900">
                  {t('about.vision')}
                </span>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {t('about.visionText')}
              </p>
            </div>
          </div>

          <div className="mt-6 flex flex-wrap gap-2">
            {['value1', 'value2', 'value3'].map((v) => (
              <span
                key={v}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs font-medium"
              >
                <i className="ri-checkbox-circle-line"></i>
                {t(`about.${v}`)}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}